import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { CardCenterService } from 'src/app/pages/card-center/card-center.service';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { ProgressBarComponent } from 'src/app/shared/components/progress-bar/progress-bar.component';
import { UserAvatarComponent } from 'src/app/shared/components/user-avatar/user-avatar.component';
import { ClickOutsideModule } from 'src/app/shared/directive/click-outside/click-outside.module';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

@UntilDestroy()
@Component({
  selector: 'app-left-menu-profile-info',
  standalone: true,
  imports: [CSButtonComponent, UserAvatarComponent, ProgressBarComponent, ClickOutsideModule, PipesModule],
  templateUrl: './left-menu-profile-info.component.html',
  styleUrl: './left-menu-profile-info.component.scss',
})
export class LeftMenuProfileInfoComponent implements OnInit {
  constructor(
    private appService: AppService,
    private cardCenterService: CardCenterService,
    private router: Router,
  ) {}

  /** 用户名 */
  protected userName = 'Unknown';

  /** 卡券数量 */
  protected bounsCount = 0;

  /** 用户头像圖片資源 */
  protected avatarImgSrc = '';

  /** vip圖片資源 */
  protected vipImgSrc = '';

  /** 当前vip等级 */
  protected currentVipLevel = 0;

  /** 是否為超級vip等级 */
  protected isSuperVip = false;

  /** 经验条值 */
  experienceProgressValue = 40;

  userInfo: AccountInforData | null = null;

  ngOnInit(): void {
    // 订阅当前登录账号信息
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe((x: AccountInforData | null) => {
      this.userInfo = x;
      this.userName = x?.userName || x?.uid || '';
      // this.avatarImgSrc = x?.avater || '';
      this.isSuperVip = x?.isSvip ?? false;
      if (x?.isSVip) return;

      this.currentVipLevel = x?.viPGrade ?? 0;
      this.vipImgSrc = `assets/images/vip/vip_${this.currentVipLevel}.png`;
    });

    this.cardCenterService.bounsCount$
      .pipe(untilDestroyed(this))
      .subscribe(bounsCount => (this.bounsCount = bounsCount || 0));
  }

  jumpToPage(page: string) {
    this.router.navigateByUrl(`/${this.appService.languageCode}/` + page);
  }
}
